import { Content } from 'src/contexts/ContentContext';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { ContentId } from 'src/utils/constants/contentId';
import { Feature } from 'src/WebApiController';

import { useAlertWithSuppressionDialog } from './useAlertWithSuppressionDialog';
import { useEventConfirmationDialogSuppressionTimestamp } from './useEventConfirmationDialogSuppressionTimestamp';

export function useSuspiciousPriceChangeDialog(
  onOkay: () => void,
  onCancel: () => void,
  viagogoVirtualId?: string | null
) {
  const { value, ...rest } = useAlertWithSuppressionDialog(
    'suspiciousPriceSuppressionTimestamp',
    onOkay,
    onCancel
  );

  const hasSellerEventAlertMutesFeature = useUserHasFeature(
    Feature.SellerEventAlertMutes
  );

  const eventLastTimeStamp = useEventConfirmationDialogSuppressionTimestamp(
    'suspiciousPriceSuppressionTimestamp',
    viagogoVirtualId
  );

  const lastTimeStamp =
    hasSellerEventAlertMutesFeature && viagogoVirtualId
      ? eventLastTimeStamp
      : value?.suspiciousPriceSuppressionTimestamp;

  return {
    ...rest,
    lastTimeStamp,
    bodyText: <Content id={ContentId.SuspiciousPriceChangeWarning} />,
  };
}
